import { graphClient } from "../graph-client";
import { GET_ANY_PROFILE, GET_PROFILE } from "./gql";
import { Profile, ProfileOther } from "./types";

class ProfileService {
  async get() {
    const client = graphClient;

    const request = await client.request<Profile.Output>(GET_PROFILE);

    return request?.getProfile;
  }

  async getOther(params: ProfileOther.Input) {
    const client = graphClient;

    const request = await client.request<ProfileOther.Output>(GET_ANY_PROFILE, {
      ...params,
    });

    return request?.getAnyProfile;
  }

  // async getList({ take, skip, ...params }: Profiles.Input) {
  //   const client = graphClient;

  //   const request = await client.request<Profiles.Output>(GET_USERS, {
  //     ...params,
  //     take,
  //     skip,
  //   });

  //   return request?.getUsers;
  // }

  // async update(params: UpdateProfile.Input) {
  //   const client = graphClient;

  //   const request = await client.request<UpdateProfile.Output>(UPDATE_PROFILE, {
  //     ...params,
  //   });

  //   return request?.updateProfile;
  // }

  // async removeUserPhoto(params: RemoveUserPhoto.Input) {
  //   const client = graphClient;

  //   const request = await client.request<RemoveUserPhoto.Output>(
  //     REMOVE_USER_PHOTO,
  //     { ...params }
  //   );

  //   return request?.removeUserPhoto;
  // }
}

export const profileService = new ProfileService();
